Object.defineProperty(exports, "__esModule", {
  value: true
});
var isObj = function isObj(obj) {
  return Object.prototype.toString.call(obj) === '[object Object]';
};
var isArray = function isArray(arr) {
  return Object.prototype.toString.call(arr) === '[object Array]';
};

exports['default'] = function (object) {
  var result = [];

  var step = function step(parts) {
    var path = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    return Object.keys(parts).forEach(function (key) {
      var value = parts[key];
      var nexPath = path.length > 0 ? String(path) + '.' + String(key) : key;
      if (isArray(value) || isObj(value)) {
        step(value, nexPath);
      } else if (isArray(parts)) {
        if (result.indexOf(path) === -1) {
          result.push(path);
        }
      } else {
        result.push(nexPath);
      }
    });
  };

  step(object);

  return result;
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/formera/lib/helpers/deepKeys.js
// module id = 210
// module chunks = 0